"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncationMixin = void 0;
var _styledComponents = require("styled-components");
/** @mixin truncationMixin */
/**
 * Truncates a block of text and displays an ellipsis (…) at the end
 * of the last line. Defaults to truncating at one line.
 *
 * @example
 * import { truncationMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *      ${truncationMixin()}
 * `;
 *
 * <Component>A long block of text...</Component>
 *
 * @method
 * @param {number} numOfLines - The maximum number of lines to display
 * before truncating. Set to "none" to turn off truncation.
 *
 * [Jan 2022] There's a bug where "none" is not accepted in Chrome/Saf/Edge even
 * though the spec dictates that "none" should be the initial value. So for now,
 * we'll the map "none" to "initial".
 * @return {CSSObject}
 */
var truncationMixin = function truncationMixin(numOfLines) {
  if (numOfLines === void 0) {
    numOfLines = 1;
  }
  return (0, _styledComponents.css)(["display:-webkit-box;-webkit-line-clamp:", ";-webkit-box-orient:vertical;overflow:hidden;"], numOfLines === 'none' ? 'initial' : numOfLines);
};
exports.truncationMixin = truncationMixin;